module.exports = __webpack_public_path__ + "img/[阴险].1a6dd41a.svg";